// extracted by mini-css-extract-plugin
export default {"grid":"ArchiveContent_grid__a8qxf"};